// @flow
import type { TAction } from './index';
import Config from '../lib/Config';
import actionTypes from './actionTypes';


function getInitialState(): Config {
  return Config.init({});
}

export default function reducer(state: Config = getInitialState(), action: TAction): Config {
  switch (action.type) {
    case actionTypes.FETCH_LINK_TOKEN:
    case actionTypes.FETCH_CONFIG:
      return Config.init({ ...state.toObject(), ...action.payload.config.toObject() });
    default: return state;
  }
}
